const baseOptions = {
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  sampleRate: 1,
  enabled: process.env.NEXT_PUBLIC_STAGE !== 'LOC',
  environment: process.env.NEXT_PUBLIC_STAGE,
  normalizeDepth: 6,
  // ZEP-591 카나리 코호트 분리: release 는 커밋 SHA 계약이라 Vercel/EKS 가 같은 커밋을
  // 빌드하면 구분 불가 → next.config.js env 블록에서 빌드타임 유도된 오리진을 태그로 남긴다.
  // base 에 두어 client/server/edge 세 런타임 모두 동일 태그를 받는다 (instrumentation.ts 포함).
  initialScope: {
    tags: {
      deployment_origin: process.env.NEXT_PUBLIC_DEPLOYMENT_ORIGIN ?? 'unknown',
    },
  },
};

export default baseOptions;
